import { useMutation } from "@tanstack/react-query";
import { apiBase } from "../apis";
import { isAuthenticated } from "@utils/auth";

export const useMutationData = (getUrl, config, options) => {
  return useMutation({
    mutationFn: (data) => {
      const url = typeof getUrl === "function" ? getUrl(data) : getUrl;
      
      if (!isAuthenticated()) {
        return Promise.reject(new Error("User not authenticated"));
      }
      
      return apiBase({ url, data, ...config });
    },
    ...options,
  });
};
